import React, { useState } from "react";
import { Modal, Loader } from "../reusable";
import { db } from "../config/firebase-config";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, updateDoc, setDoc, getDoc } from "firebase/firestore";
import "./ResumeUploadModal.css";

export default function ResumeUploadModal({ isOpen, onClose, userId, addAlert }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError("");
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Please select a file.");
      return;
    }
    setUploading(true);
    setError("");
    try {
      const storage = getStorage();
      const storageRef = ref(storage, `resumes/${userId}/${file.name}`);
      await uploadBytes(storageRef, file);
      // Always get the download URL from Firebase Storage
      const downloadURL = await getDownloadURL(storageRef);
      const storagePath = `resumes/${userId}/${file.name}`;
      // Save both the download URL and the storage path to Firestore
      const userProfileRef = doc(db, "creator-profiles", userId);
      const userProfileSnap = await getDoc(userProfileRef);
      if (userProfileSnap.exists()) {
        await updateDoc(userProfileRef, { resume: downloadURL, resumePath: storagePath });
      } else {
        await setDoc(userProfileRef, { resume: downloadURL, resumePath: storagePath }, { merge: true });
      }
      setUploading(false);
      setFile(null);
      addAlert && addAlert({ type: "success", message: "Resume uploaded successfully!" });
      onClose && onClose();
    } catch (err) {
      setError("Failed to upload resume. Please try again.");
      setUploading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={<div style={{textAlign:'center', width:'100%'}}>Upload Resume</div>}>
      <div className="resume-upload-modal-content" onClick={e => e.stopPropagation()}>
        <input
          className="resume-upload-input"
          type="file"
          accept=".pdf,.doc,.docx"
          onChange={handleFileChange}
          disabled={uploading}
        />
        {error && <div className="resume-upload-error">{error}</div>}
        <button
          className="resume-upload-btn"
          onClick={handleUpload}
          disabled={uploading || !file}
        >
          {uploading ? <Loader size={18} /> : "Upload"}
        </button>
      </div>
    </Modal>
  );
}
